/**
 * @generated SignedSource<<cdd2bbdf7b638087047fc738027c5224>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PermissionType = "ANALYTICS_VIEWER" | "BADGE_ADMIN" | "BILLING_ADMIN" | "CLUB_ADMIN" | "COURSE_ADMIN" | "GROUP_ADMIN" | "INTEGRATION_ADMIN" | "MEMBER_ADMIN" | "MODERATOR" | "PERMISSION_ADMIN" | "PERMISSION_VIEWER" | "PINNED_LINK" | "POST_ADMIN" | "POST_PIN" | "SEGMENT_ADMIN" | "SEGMENT_VIEWER" | "SPACE_ADMIN" | "TAG_ADMIN" | "%future added value";
export type routeAdminClubQuery$variables = {
  slug: string;
};
export type routeAdminClubQuery$data = {
  readonly club: {
    readonly domains: ReadonlyArray<{
      readonly domain: string;
      readonly enabled: boolean;
    }>;
    readonly id: string;
    readonly logo: {
      readonly signedUrl: string;
    } | null | undefined;
    readonly name: string;
    readonly permissions: ReadonlyArray<{
      readonly slug: PermissionType;
    }>;
    readonly slug: string;
    readonly themes: ReadonlyArray<{
      readonly styles: any;
    }> | null | undefined;
  };
  readonly user: {
    readonly clubs: ReadonlyArray<{
      readonly id: string;
      readonly logo: {
        readonly signedUrl: string;
      } | null | undefined;
      readonly name: string;
      readonly slug: string;
    }>;
  } | null | undefined;
};
export type routeAdminClubQuery = {
  response: routeAdminClubQuery$data;
  variables: routeAdminClubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageFile",
  "kind": "LinkedField",
  "name": "logo",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Permission",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ClubTheme",
  "kind": "LinkedField",
  "name": "themes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "styles",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "domain",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageFile",
  "kind": "LinkedField",
  "name": "logo",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routeAdminClubQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "clubs",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v2/*: any*/),
          (v7/*: any*/),
          (v5/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Domain",
            "kind": "LinkedField",
            "name": "domains",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routeAdminClubQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "clubs",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v2/*: any*/),
          (v7/*: any*/),
          (v11/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Domain",
            "kind": "LinkedField",
            "name": "domains",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f1ae79d348de5eb8cf8ca1eec7815a4e",
    "id": null,
    "metadata": {},
    "name": "routeAdminClubQuery",
    "operationKind": "query",
    "text": "query routeAdminClubQuery(\n  $slug: String!\n) {\n  user {\n    clubs {\n      id\n      slug\n      name\n      logo {\n        signedUrl\n        id\n      }\n    }\n    id\n  }\n  club(slug: $slug) {\n    id\n    name\n    slug\n    permissions {\n      slug\n    }\n    logo {\n      signedUrl\n      id\n    }\n    themes {\n      styles\n    }\n    domains {\n      enabled\n      domain\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2205d230cd2ffd2af0a3230dbdb6f09d";

export default node;
